module.exports = __webpack_public_path__ + "images/newerp_button2.1788773129009.png";